import { HudUI } from './hudUI.js';

/** Build HudUI from getDomElements() map (keeps app.js under max-lines). */
export function createHudFromDom(dom) {
  return new HudUI({
    playerNamePlate: dom.playerNamePlate,
    playerHpBar: dom.playerHpBar,
    playerTurretAlert: dom.playerTurretAlert,
    playerPlate: dom.playerPlate,
    levelText: dom.levelText,
    goldText: dom.goldText,
    adStatText: dom.adStatText,
    asStatText: dom.asStatText,
    msStatText: dom.msStatText,
    expBarInner: dom.expBarInner,
    qSkillSlot: dom.qSkillSlot,
    qCdOverlay: dom.qCdOverlay,
    wSkillSlot: dom.wSkillSlot,
    wCdOverlay: dom.wCdOverlay,
    eSkillSlot: dom.eSkillSlot,
    eCdOverlay: dom.eCdOverlay,
    rSkillSlot: dom.rSkillSlot,
    rCdOverlay: dom.rCdOverlay,
    dSkillSlot: dom.dSkillSlot,
    dCdOverlay: dom.dCdOverlay,
    dSpellAbbr: dom.dSpellAbbr,
    fSkillSlot: dom.fSkillSlot,
    fCdOverlay: dom.fCdOverlay,
    fSpellAbbr: dom.fSpellAbbr,
    windupBarInner: dom.windupBarInner,
    selectionReticleMesh: null,
    minionsUiContainer: dom.minionsUiContainer,
    turretsUiContainer: dom.turretsUiContainer
  });
}
